import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { toReportDayIso } from "src/app/cards/reports/reports-date.utils";

export interface IConfirmedProductsReportDialogResult {
  from: string;
  to: string;
}

@Component({
  selector: "confirmed-products-report-dialog",
  host: { class: "dialog" },
  templateUrl: "./confirmed-products-report.dialog.html",
  styleUrls: ["./confirmed-products-report.dialog.scss"]
})
export class ConfirmedProductsReportDialog {
  public formGroup = new FormGroup({
    from: new FormControl(null, Validators.required),
    to: new FormControl(null, Validators.required)
  });

  constructor(
    public dialogRef: MatDialogRef<ConfirmedProductsReportDialog, IConfirmedProductsReportDialogResult>
  ) { }

  public submit() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    const { from, to } = this.formGroup.value;

    this.dialogRef.close({
      from: toReportDayIso(from),
      to: toReportDayIso(to)
    });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
